import { DEFAULT_MEETING_TYPE } from '../selectors/isDefaultMeetingType';
import enableDisableMeetingType from '../utils/enableDisableMeetingType';

/**
 * Function to delete default meeting type
 * Default meeting type can not be deleted because it's required by booking backend services
 * As a workaround, we can "fake" the deletion by hiding the meeting type from both organizer
 * and attendee pages.
 * For attendee page, meetingType.ExcludedFromSerivce = true
 * For organizer's page, meetingType.ExcludedFromService = true + no meeting type extension
 */
export default async function deleteDefaultMeetingType(): Promise<boolean> {
    return enableDisableMeetingType(DEFAULT_MEETING_TYPE, false /*shouldBeEnabled*/);
}
